import { ReplaySubject, Subject } from "rxjs";


/*
  * This subject is used to notify when the map boundaries have been updated,
  * so that other plugins can react to it if needed.
*/
const mapBoundariesUpdated$ = new Subject();

/*
  * This subject is used to notify when the user is searching by current location.
  *
  * Uses ReplaySubject(1) so that if geolocation permission is granted before the
  * map plugin has started (and subscribed), the emission is buffered and delivered
  * as soon as the subscriber attaches. A plain Subject would silently drop the
  * value and the map would never re-center.
*/
const currentLocationProvided$ = new ReplaySubject(1);

/*
  * This subject is used to notify when the user taps a site plan area on mobile.
  * Emits the communityId of the tapped site plan.
*/
const sitePlanTapped$ = new Subject();

/*
  * This subject is used to notify when the user hovers over a site plan area.
  * Emits { communityId } of the hovered site plan.
*/
const sitePlanHovered$ = new Subject();

/*
  * This subject is used to notify when the user stops hovering over a site plan area.
  * Emits { communityId } of the previously-hovered site plan.
*/
const sitePlanHoverEnded$ = new Subject();

/*
  * This subject is used to notify when the user explicitly selects a location
  * (i.e. a fetchLocations dispatch with valid origin coordinates — typically from
  * the search bar typeahead). Emits { latitude, longitude } every time, even when
  * re-selecting the location that is already active.
  *
  * Populated by locationSelectedEpic, which observes the fetchLocations ACTION
  * itself rather than the resulting Redux state — reacting to derived state can't
  * distinguish "the user re-selected the same location" from "nothing happened",
  * since both leave the state value unchanged.
*/
const locationSelected$ = new Subject();

export {
  mapBoundariesUpdated$,
  currentLocationProvided$,
  sitePlanTapped$,
  sitePlanHovered$,
  sitePlanHoverEnded$,
  locationSelected$,
};